drawValueDirection();